__turbopack_context__.v({
  "badgesRow": "HeroSection-module__fYnnSG__badgesRow",
  "blink": "HeroSection-module__fYnnSG__blink",
  "btnPrimary": "HeroSection-module__fYnnSG__btnPrimary",
  "btnSecondary": "HeroSection-module__fYnnSG__btnSecondary",
  "centerNode": "HeroSection-module__fYnnSG__centerNode",
  "connectingLines": "HeroSection-module__fYnnSG__connectingLines",
  "container": "HeroSection-module__fYnnSG__container",
  "cursor": "HeroSection-module__fYnnSG__cursor",
  "fadeIn": "HeroSection-module__fYnnSG__fadeIn",
  "fadeInUp": "HeroSection-module__fYnnSG__fadeInUp",
  "glowOrb": "HeroSection-module__fYnnSG__glowOrb",
  "gridScroll": "HeroSection-module__fYnnSG__gridScroll",
  "hero": "HeroSection-module__fYnnSG__hero",
  "heroActions": "HeroSection-module__fYnnSG__heroActions",
  "heroBadge": "HeroSection-module__fYnnSG__heroBadge",
  "heroDescription": "HeroSection-module__fYnnSG__heroDescription",
  "heroGrid": "HeroSection-module__fYnnSG__heroGrid",
  "heroTitle": "HeroSection-module__fYnnSG__heroTitle",
  "iconCircle": "HeroSection-module__fYnnSG__iconCircle",
  "line": "HeroSection-module__fYnnSG__line",
  "march": "HeroSection-module__fYnnSG__march",
  "node1": "HeroSection-module__fYnnSG__node1",
  "node2": "HeroSection-module__fYnnSG__node2",
  "node3": "HeroSection-module__fYnnSG__node3",
  "node4": "HeroSection-module__fYnnSG__node4",
  "node5": "HeroSection-module__fYnnSG__node5",
  "node6": "HeroSection-module__fYnnSG__node6",
  "node7": "HeroSection-module__fYnnSG__node7",
  "node8": "HeroSection-module__fYnnSG__node8",
  "nodeInfo": "HeroSection-module__fYnnSG__nodeInfo",
  "nodeSub": "HeroSection-module__fYnnSG__nodeSub",
  "nodeTitle": "HeroSection-module__fYnnSG__nodeTitle",
  "orbGold": "HeroSection-module__fYnnSG__orbGold",
  "orbOrange": "HeroSection-module__fYnnSG__orbOrange",
  "orbitNode": "HeroSection-module__fYnnSG__orbitNode",
  "popIn": "HeroSection-module__fYnnSG__popIn",
  "pulseOrb": "HeroSection-module__fYnnSG__pulseOrb",
  "pulseRing": "HeroSection-module__fYnnSG__pulseRing",
  "radialContainer": "HeroSection-module__fYnnSG__radialContainer",
  "separator": "HeroSection-module__fYnnSG__separator",
  "shootOut": "HeroSection-module__fYnnSG__shootOut",
  "textContent": "HeroSection-module__fYnnSG__textContent",
  "textGradient": "HeroSection-module__fYnnSG__textGradient",
  "trustBadges": "HeroSection-module__fYnnSG__trustBadges",
  "visualContent": "HeroSection-module__fYnnSG__visualContent",
});
